(function (factory) {
  if (typeof define === 'function' && define.amd)
    define(['exports', './kotlin-kotlin-stdlib.js', './kotlinx-coroutines-core.js'], factory);
  else if (typeof exports === 'object')
    factory(module.exports, require('./kotlin-kotlin-stdlib.js'), require('./kotlinx-coroutines-core.js'));
  else {
    if (typeof globalThis['kotlin-kotlin-stdlib'] === 'undefined') {
      throw new Error("Error loading module 'MultiplatformSettings-multiplatform-settings-coroutines'. Its dependency 'kotlin-kotlin-stdlib' was not found. Please, check whether 'kotlin-kotlin-stdlib' is loaded prior to 'MultiplatformSettings-multiplatform-settings-coroutines'.");
    }
    if (typeof globalThis['kotlinx-coroutines-core'] === 'undefined') {
      throw new Error("Error loading module 'MultiplatformSettings-multiplatform-settings-coroutines'. Its dependency 'kotlinx-coroutines-core' was not found. Please, check whether 'kotlinx-coroutines-core' is loaded prior to 'MultiplatformSettings-multiplatform-settings-coroutines'.");
    }
    globalThis['MultiplatformSettings-multiplatform-settings-coroutines'] = factory(typeof globalThis['MultiplatformSettings-multiplatform-settings-coroutines'] === 'undefined' ? {} : globalThis['MultiplatformSettings-multiplatform-settings-coroutines'], globalThis['kotlin-kotlin-stdlib'], globalThis['kotlinx-coroutines-core']);
  }
}(function (_, kotlin_kotlin, kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core) {
  'use strict';
  //region block: imports
  var VOID = kotlin_kotlin.$_$.d;
  var CoroutineImpl = kotlin_kotlin.$_$.xd;
  var Unit_instance = kotlin_kotlin.$_$.o3;
  var protoOf = kotlin_kotlin.$_$.eh;
  var THROW_CCE = kotlin_kotlin.$_$.sn;
  var CoroutineScope = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.y2;
  var isInterface = kotlin_kotlin.$_$.rg;
  var initMetadataForLambda = kotlin_kotlin.$_$.hg;
  var constructCallableReference = kotlin_kotlin.$_$.of;
  var withContext = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.a1;
  var initMetadataForClass = kotlin_kotlin.$_$.cg;
  var Dispatchers_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.h;
  //endregion
  //region block: pre-declaration
  initMetadataForLambda(SuspendSettingsWrapper$remove$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(SuspendSettingsWrapper$putString$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(SuspendSettingsWrapper$getStringOrNull$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(SuspendSettingsWrapper, 'SuspendSettingsWrapper', VOID, VOID, VOID, [0, 1, 2]);
  //endregion
  function toSuspendSettings(_this__u8e3s4, dispatcher) {
    dispatcher = dispatcher === VOID ? get_converterDefaultDispatcher() : dispatcher;
    return new SuspendSettingsWrapper(_this__u8e3s4, dispatcher);
  }
  function SuspendSettingsWrapper$remove$slambda(this$0, $key, resultContinuation) {
    this.gvu_1 = this$0;
    this.hvu_1 = $key;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(SuspendSettingsWrapper$remove$slambda).p24 = function ($this$withContext, $completion) {
    var tmp = this.q24($this$withContext, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(SuspendSettingsWrapper$remove$slambda).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(SuspendSettingsWrapper$remove$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        if (tmp === 0) {
          this.o9_1 = 1;
          this.gvu_1.jvu_1.jsq(this.hvu_1);
          return Unit_instance;
        } else if (tmp === 1) {
          throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(SuspendSettingsWrapper$remove$slambda).q24 = function ($this$withContext, completion) {
    var i = new SuspendSettingsWrapper$remove$slambda(this.gvu_1, this.hvu_1, completion);
    i.ivu_1 = $this$withContext;
    return i;
  };
  function SuspendSettingsWrapper$remove$slambda_0(this$0, $key, resultContinuation) {
    var i = new SuspendSettingsWrapper$remove$slambda(this$0, $key, resultContinuation);
    return constructCallableReference(function ($this$withContext, $completion) {
      return i.p24($this$withContext, $completion);
    }, 1);
  }
  function SuspendSettingsWrapper$putString$slambda(this$0, $key, $value, resultContinuation) {
    this.tvu_1 = this$0;
    this.uvu_1 = $key;
    this.vvu_1 = $value;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(SuspendSettingsWrapper$putString$slambda).p24 = function ($this$withContext, $completion) {
    var tmp = this.q24($this$withContext, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(SuspendSettingsWrapper$putString$slambda).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(SuspendSettingsWrapper$putString$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        if (tmp === 0) {
          this.o9_1 = 1;
          this.tvu_1.jvu_1.wvt(this.uvu_1, this.vvu_1);
          return Unit_instance;
        } else if (tmp === 1) {
          throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(SuspendSettingsWrapper$putString$slambda).q24 = function ($this$withContext, completion) {
    var i = new SuspendSettingsWrapper$putString$slambda(this.tvu_1, this.uvu_1, this.vvu_1, completion);
    i.wvu_1 = $this$withContext;
    return i;
  };
  function SuspendSettingsWrapper$putString$slambda_0(this$0, $key, $value, resultContinuation) {
    var i = new SuspendSettingsWrapper$putString$slambda(this$0, $key, $value, resultContinuation);
    return constructCallableReference(function ($this$withContext, $completion) {
      return i.p24($this$withContext, $completion);
    }, 1);
  }
  function SuspendSettingsWrapper$getStringOrNull$slambda(this$0, $key, resultContinuation) {
    this.fvv_1 = this$0;
    this.gvv_1 = $key;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(SuspendSettingsWrapper$getStringOrNull$slambda).ivv = function ($this$withContext, $completion) {
    var tmp = this.q24($this$withContext, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(SuspendSettingsWrapper$getStringOrNull$slambda).ja = function (p1, $completion) {
    return this.ivv((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(SuspendSettingsWrapper$getStringOrNull$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        if (tmp === 0) {
          this.o9_1 = 1;
          return this.fvv_1.jvu_1.xvt(this.gvv_1);
        } else if (tmp === 1) {
          throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(SuspendSettingsWrapper$getStringOrNull$slambda).q24 = function ($this$withContext, completion) {
    var i = new SuspendSettingsWrapper$getStringOrNull$slambda(this.fvv_1, this.gvv_1, completion);
    i.hvv_1 = $this$withContext;
    return i;
  };
  function SuspendSettingsWrapper$getStringOrNull$slambda_0(this$0, $key, resultContinuation) {
    var i = new SuspendSettingsWrapper$getStringOrNull$slambda(this$0, $key, resultContinuation);
    return constructCallableReference(function ($this$withContext, $completion) {
      return i.ivv($this$withContext, $completion);
    }, 1);
  }
  function SuspendSettingsWrapper(delegate, dispatcher) {
    this.jvu_1 = delegate;
    this.kvu_1 = dispatcher;
  }
  protoOf(SuspendSettingsWrapper).jvv = function (key, $completion) {
    return withContext(this.kvu_1, SuspendSettingsWrapper$remove$slambda_0(this, key, null), $completion);
  };
  protoOf(SuspendSettingsWrapper).kvv = function (key, value, $completion) {
    return withContext(this.kvu_1, SuspendSettingsWrapper$putString$slambda_0(this, key, value, null), $completion);
  };
  protoOf(SuspendSettingsWrapper).lvv = function (key, $completion) {
    return withContext(this.kvu_1, SuspendSettingsWrapper$getStringOrNull$slambda_0(this, key, null), $completion);
  };
  function get_converterDefaultDispatcher() {
    _init_properties_ConverterDefaultDispatcher_kt__9uwxlk();
    return converterDefaultDispatcher;
  }
  var converterDefaultDispatcher;
  var properties_initialized_ConverterDefaultDispatcher_kt_im3w8m;
  function _init_properties_ConverterDefaultDispatcher_kt__9uwxlk() {
    if (!properties_initialized_ConverterDefaultDispatcher_kt_im3w8m) {
      properties_initialized_ConverterDefaultDispatcher_kt_im3w8m = true;
      converterDefaultDispatcher = Dispatchers_getInstance().i1h_1;
    }
  }
  //region block: exports
  _.$_$ = _.$_$ || {};
  _.$_$.a = toSuspendSettings;
  //endregion
  return _;
}));

//# sourceMappingURL=MultiplatformSettings-multiplatform-settings-coroutines.js.map
